import React, {Component} from 'react';
import {Form, Button, Radio, Select, Input, Divider, message, Slider} from 'antd';
import {corpus} from './corpus';
import {buildIpsum} from './helpers';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const Option = Select.Option;
const {TextArea} = Input;

const numParagraphs = {'壹': 1, '贰': 2, '叁': 3, '肆': 4, '伍': 5};
const paragraphsLengthMap = {'0': 1, '33': 3, '66': 5, '99': 7};
const sources = Object.keys(corpus);

const marks = {
  0: '',
  33: '',
  66: '',
  99: '',
};

function formatter(value) {
  switch (value) {
    case 0:
      return '一阳指';
    case 33:
      return '九阳神功';
    case 66:
      return '降龙十八掌';
    case 99:
      return '八荒六合唯我独尊';
    default:
      return `${value}%`;
  }
}

class Main extends Component {

  handleSubmit = (evt) => {
    evt.preventDefault();
    const {form} = this.props;
    const {numParagraphs, paragraphsLength, sources} = form.getFieldsValue();
    const ipsum = buildIpsum(numParagraphs, paragraphsLengthMap[paragraphsLength.toString()], sources);

    form.setFields({
      ipsum: {
        value: ipsum
      },
    })
  };

  handleCopy = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(this.props.form.getFieldValue('ipsum'))
        .then(() => {
          message.success('已复制到剪贴板');
        })
        .catch(err => {
          message.error('您使用的浏览器不支持复制功能');
        });
    } else {
      message.error('您使用的浏览器不支持复制功能');
    }
  };

  render() {
    const {getFieldDecorator, getFieldValue, getFieldError} = this.props.form;
    const submitDisabled = getFieldError('sources');
    const copyDisabled = !getFieldValue('ipsum');

    return (
      <Form onSubmit={this.handleSubmit} id={'main'} size='large'>
        <FormItem
          label="段落"
          size='large'
          colon={false}
        >
          {getFieldDecorator('numParagraphs', {initialValue: numParagraphs['叁']})(
            <RadioGroup size='large'>
              {Object.keys(numParagraphs).map(key =>
                <Radio.Button
                size='large'
                  value={numParagraphs[key]}
                  key={key}>{key}</Radio.Button>
              )}
            </RadioGroup>
          )}
        </FormItem>
        <FormItem
          label="长度"
          colon={false}
        >

          {getFieldDecorator('paragraphsLength', {initialValue: 66})(
            <Slider marks={marks} tipFormatter={formatter} step={33}/>
          )}
        </FormItem>
        <FormItem
          label="来源"
          colon={false}
          >
          {getFieldDecorator('sources',
            {
              initialValue: ['鹿鼎记', '笑傲江湖', '倚天屠龙记', '神雕侠侣', '书剑恩仇录'],
              rules: [
                {required: true, message: '请选择文稿的来源'},
              ]
            }
          )(<Select
            required
            mode="tags"
            size='large'
            style={{width: '100%', maxWidth: 360 }}
            placeholder="请选择文稿来源"
            maxTagCount={5}
          >
            {sources.map(src => <Option style={{fontSize: '16px'}} key={src}>{src}</Option>)}
          </Select>)}
        </FormItem>
        <FormItem
          
        >
          <Divider size='large'>结果如下</Divider>

          {getFieldDecorator('ipsum')(
            <TextArea
            size='large'
              style={{resize: 'none'}}
              rows={12}
            />)}
        </FormItem>
        <FormItem style={{textAlign: 'center'}}>
          <Button style={navigator.clipboard ? {marginRight: '.5rem'} : {}}
                  type="primary"
                  htmlType="submit"
                  size={'large'}
                  disabled={submitDisabled}
          >产生</Button>
          {navigator.clipboard && <Button style={{marginLeft: '.5rem'}}
                                          disabled={copyDisabled}
                                          onClick={this.handleCopy}
                                          size={'large'}
                                          type="secondary">
            复制
          </Button>}
        </FormItem>
      </Form>
    );
  }
}

export default Form.create()(Main);